export default __webpack_public_path__ + "static/media/Google_Color.9b21f453.svg";